import { returnPolicyIdFormat } from "@redotech/redo-return-id";
import * as z from "zod";

/** Copies one version's settings into the policy's draft, to review and publish. */
export const restoreReturnPolicyVersion = {
  name: "restoreReturnPolicyVersion" as const,
  input: z.object({
    id: returnPolicyIdFormat.schema,
    versionNumber: z.number().int(),
  }),
  output: z.object({ updatedAt: z.date() }),
};
